import { render, staticRenderFns } from "./RoleAccessDetail.vue?vue&type=template&id=7899de4d&scoped=true&"
import script from "./RoleAccessDetail.vue?vue&type=script&lang=js&"
export * from "./RoleAccessDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7899de4d",
  null
  
)

export default component.exports